import { render, staticRenderFns } from "./ls-upload.vue?vue&type=template&id=70216e0f&scoped=true"
import script from "./ls-upload.vue?vue&type=script&lang=ts"
export * from "./ls-upload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70216e0f",
  null
  
)

export default component.exports